/**
 * Registers a new block provided a unique name and an object defining its behavior.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
import { registerBlockType } from '@wordpress/blocks';
import domReady from '@wordpress/dom-ready';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * All files containing `style` keyword are bundled together. The code used
 * gets applied both to the front of your site and to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './style.scss';

/**
 * Internal dependencies
 */
import Edit from './edit';
import metadata from './block.json';

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
registerBlockType(metadata, {
  edit: Edit,
  save() {
    return null;
  },
});

/**
 * Function to ensure filter navigation opens only one menu at at time
 */
const setFilterNavigationOpenState = () => {
  const sffedNavigationFilterDetails = document.querySelectorAll('.sffed-navigation__filter--details');

  if (sffedNavigationFilterDetails.length > 0) {
    const closeAllDetails = (activeDetail) => {
      sffedNavigationFilterDetails.forEach(detail => {
        if (detail !== activeDetail) {
          detail.removeAttribute('open');
        }
      });
    };

    document.addEventListener('click', event => {
      const detail = event.target.closest('details');
      if (detail) {
        closeAllDetails(detail);
      }
    });
  }
};

domReady(setFilterNavigationOpenState);
